import React from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

const cols = [
  {
    title: "Products",
    links: [
      { label: "All Products", to: "/products" },
      { label: "AI Inventory", to: "/products/ai-inventory-compliance-governance" },
      { label: "Policy Engine", to: "/products/ai-inventory-compliance-governance#how-it-works" },
      { label: "Frameworks", to: "/products/ai-inventory-compliance-governance" },
      { label: "Integrations", to: "/products/ai-inventory-compliance-governance" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", to: "/#about" },
      { label: "Case Studies", to: "/case-studies" },
      { label: "Blog", to: "/blog" },
      { label: "Contact", to: "/#contact" },
    ],
  },
  {
    title: "Services",
    links: [
      { label: "Cloud-Native Apps", to: "/#services" },
      { label: "Migrations", to: "/#services" },
      { label: "Modernization", to: "/#services" },
      { label: "Advisory", to: "/#contact" },
    ],
  },
];

export const Footer = () => {
  return (
    <footer className="bg-zinc-950 text-white">
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-12 py-20 grid grid-cols-12 gap-10 border-t border-zinc-800">
        <div className="col-span-12 md:col-span-5">
          <Logo invert />
          <p className="mt-5 text-sm text-zinc-400 max-w-sm leading-relaxed">
            Jaisphere is an IT Solutions & Services company helping enterprises adopt AI with
            confidence. Founded 2008 · Atlanta, Georgia.
          </p>
          <a
            href="mailto:jaisphere@gmail.com"
            className="mt-5 inline-block text-sm text-zinc-200 hover:text-white border-b border-zinc-600 hover:border-white"
          >
            jaisphere@gmail.com
          </a>
        </div>

        {cols.map((c) => (
          <div key={c.title} className="col-span-6 md:col-span-2">
            <div className="text-[11px] font-mono uppercase tracking-widest text-zinc-500">
              {c.title}
            </div>
            <ul className="mt-4 space-y-2.5">
              {c.links.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="text-sm text-zinc-300 hover:text-white">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div className="col-span-12 md:col-span-1">
          <div className="text-[11px] font-mono uppercase tracking-widest text-zinc-500">Status</div>
          <div className="mt-4 inline-flex items-center gap-2 text-sm text-emerald-400">
            <span className="h-1.5 w-1.5 bg-emerald-400 rounded-full" />
            Operational
          </div>
        </div>
      </div>

      <div className="relative border-t border-zinc-800 overflow-hidden">
        <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-12 py-12 flex flex-col md:flex-row items-start md:items-end justify-between gap-6">
          <div className="text-xs text-zinc-500 font-mono uppercase tracking-widest">
            © {new Date().getFullYear()} Jaisphere · All rights reserved
          </div>
          <div className="text-xs text-zinc-500 font-mono uppercase tracking-widest">
            Privacy · Terms · Security
          </div>
        </div>

        <div
          aria-hidden
          className="select-none pointer-events-none px-6 md:px-10 lg:px-12 pb-4 font-display font-black tracking-[-0.06em] leading-none text-[18vw] text-white/[0.04]"
        >
          JAISPHERE
        </div>
      </div>
    </footer>
  );
};

export default Footer;
